export const FormSkeleton = () => {
  return (
    <div className="h-dvh bg-background text-text-primary flex flex-col">
      <div className="flex-1 flex flex-col min-h-0">
        <div className="max-w-3xl w-full mx-auto px-6 py-6 flex flex-col min-h-0">
          <div className="bg-background-surface shadow-sm p-8 flex flex-col flex-auto min-h-0 overflow-hidden animate-pulse">
            <div className="h-5 w-2/3 rounded bg-border/60 mb-6" />
            <div className="space-y-4">
              <div className="h-4 w-full rounded bg-border/50" />
              <div className="h-4 w-5/6 rounded bg-border/50" />
              <div className="h-4 w-4/6 rounded bg-border/50" />
            </div>
          </div>
          <div className="mt-auto bg-background-surface px-8 py-4 flex justify-end animate-pulse">
            <div className="h-9 w-24 rounded bg-border/60" />
          </div>
        </div>
      </div>
    </div>
  );
};
